import { useState } from "react";
import { NavLink } from "react-router-dom";
import { History, Menu, User } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { NAV_ITEMS } from "@/components/HeaderNav";

// Phone / tablet menu (below lg): every section in a slide-in panel.
export function MobileNav({ showLibrary }) {
    const [open, setOpen] = useState(false);
    const items = showLibrary ? [...NAV_ITEMS, { to: "/library", label: ["Reprendre"], icon: History }] : [...NAV_ITEMS, { to: "/login", label: ["Connexion"], icon: User }];
    return (
        <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
                <button type="button" className="xl:hidden w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ color: "#E5C679", border: "1px solid rgba(229,198,121,0.35)" }} aria-label="Ouvrir le menu" data-testid="mobile-menu-btn">
                    <Menu className="w-5 h-5" />
                </button>
            </SheetTrigger>
            <SheetContent side="left" className="w-[82vw] max-w-sm p-0 border-r-0" style={{ background: "#0B0F1A", color: "#F4EEDF" }} data-testid="mobile-menu">
                <SheetTitle className="px-6 pt-6 pb-4 font-display text-2xl" style={{ color: "#F4EEDF" }}>Savoir Utile</SheetTitle>
                <nav className="flex flex-col px-3 pb-8">
                    {items.map(({ to, label, icon: Icon, end }) => (
                        <NavLink key={to} to={to} end={end} onClick={() => setOpen(false)} data-testid={`mobile-nav-${to.replace(/\//g, "") || "home"}`}
                            className="flex items-center gap-4 px-4 py-3.5 rounded-xl text-base transition-colors duration-150"
                            style={({ isActive }) => ({ color: isActive ? "#E5C679" : "rgba(244,238,223,0.88)", background: isActive ? "rgba(229,198,121,0.10)" : "transparent" })}>
                            <Icon className="w-5 h-5" strokeWidth={1.6} />
                            {label.join(" ")}
                        </NavLink>
                    ))}
                </nav>
            </SheetContent>
        </Sheet>
    );
}
